export default {
  increment (state) {
    state.counter = state.counter + 1
  },
  decrement (state) {
    state.counter = state.counter - 1
  }
}
